import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import { getIntDictOptions, DICT_TYPE } from '@/utils/dict';
import { dateFormatter } from '@/utils/formatTime';
import { ToolApi } from '@/api/ai/model/tool';
import ToolForm from './ToolForm.vue';
import { onMounted, reactive, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import Icon from '@/components/Icon/src/Icon.vue';
/** AI 工具 列表 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'AiTool'
  },
  __name: 'index',
  setup(__props) {
    const message = useMessage(); // 消息弹窗
    // const { t } = useI18n() // 国际化
    const loading = ref(true); // 列表的加载中
    const list = ref([]); // 列表的数据
    const total = ref(0); // 列表的总页数
    const queryParams = reactive({
      pageNo: 1,
      pageSize: 10,
      name: undefined,
      description: undefined,
      status: undefined,
      createTime: []
    });
    const queryFormRef = ref(); // 搜索的表单
    const exportLoading = ref(false); // 导出的加载中
    /** 查询列表 */
    const getList = async () => {
      loading.value = true;
      try {
        const data = await ToolApi.getToolPage(queryParams);
        list.value = data.list;
        total.value = data.total;
      } finally {
        loading.value = false;
      }
    };
    /** 搜索按钮操作 */
    const handleQuery = () => {
      queryParams.pageNo = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = () => {
      queryFormRef.value.resetFields();
      handleQuery();
    };
    /** 添加/修改操作 */
    const formRef = ref();
    const openForm = (type, id) => {
      formRef.value.open(type, id);
    };
    /** 删除按钮操作 */
    const handleDelete = async id => {
      try {
        // 删除的二次确认
        await message.delConfirm();
        // 发起删除
        await ToolApi.deleteTool(id);
        // message.success(t('common.delSuccess'))
        message.success('删除成功');
        // 刷新列表
        await getList();
      } catch {}
    };
    /** 初始化 **/
    onMounted(() => {
      getList();
    });
    return (_ctx, _cache) => {
      const _component_doc_alert = _resolveComponent("doc-alert");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_dict_tag = _resolveComponent("dict-tag");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Pagination = _resolveComponent("Pagination");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_doc_alert, {
        title: "AI 工具调用（function calling）",
        url: "https://doc.iocoder.cn/ai/tool/"
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          class: "-mb-15px",
          model: queryParams,
          ref_key: "queryFormRef",
          ref: queryFormRef,
          inline: true,
          "label-width": "68px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "工具名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParams.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParams.name = $event),
              placeholder: "请输入工具名称",
              clearable: "",
              onKeyup: _withKeys(handleQuery, ["enter"]),
              class: "!w-240px"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: queryParams.status,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParams.status = $event),
              placeholder: "请选择状态",
              clearable: "",
              class: "!w-240px"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getIntDictOptions)(_unref(DICT_TYPE).COMMON_STATUS), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "创建时间",
            prop: "createTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: queryParams.createTime,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParams.createTime = $event),
              "value-format": "YYYY-MM-DD HH:mm:ss",
              type: "daterange",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "default-time": [new Date('1 00:00:00'), new Date('1 23:59:59')],
              class: "!w-220px"
            }, null, 8, ["modelValue", "default-time"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: handleQuery
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:search",
                class: "mr-5px"
              }), _cache[6] || (_cache[6] = _createTextVNode(" 搜索"))]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: resetQuery
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:refresh",
                class: "mr-5px"
              }), _cache[7] || (_cache[7] = _createTextVNode(" 重置"))]),
              _: 1
            }), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              plain: "",
              onClick: _cache[3] || (_cache[3] = $event => openForm('create'))
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:plus",
                class: "mr-5px"
              }), _cache[8] || (_cache[8] = _createTextVNode(" 新增 "))]),
              _: 1
            })), [[_directive_hasPermi, ['ai:tool:create']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          stripe: true,
          "show-overflow-tooltip": true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "工具编号",
            align: "center",
            prop: "id"
          }), _createVNode(_component_el_table_column, {
            label: "工具名称",
            align: "center",
            prop: "name"
          }), _createVNode(_component_el_table_column, {
            label: "工具描述",
            align: "center",
            prop: "description"
          }), _createVNode(_component_el_table_column, {
            label: "状态",
            align: "center",
            prop: "status"
          }, {
            default: _withCtx(scope => [_createVNode(_component_dict_tag, {
              type: _unref(DICT_TYPE).COMMON_STATUS,
              value: scope.row.status
            }, null, 8, ["type", "value"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "创建时间",
            align: "center",
            prop: "createTime",
            formatter: _unref(dateFormatter),
            width: "180px"
          }, null, 8, ["formatter"]), _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "120px"
          }, {
            default: _withCtx(scope => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => openForm('update', scope.row.id)
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode(" 编辑 ")])),
              _: 2
            }, 1032, ["onClick"])), [[_directive_hasPermi, ['ai:tool:update']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "danger",
              onClick: $event => handleDelete(scope.row.id)
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" 删除 ")])),
              _: 2
            }, 1032, ["onClick"])), [[_directive_hasPermi, ['ai:tool:delete']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(_component_Pagination, {
          total: total.value,
          page: queryParams.pageNo,
          "onUpdate:page": _cache[4] || (_cache[4] = $event => queryParams.pageNo = $event),
          limit: queryParams.pageSize,
          "onUpdate:limit": _cache[5] || (_cache[5] = $event => queryParams.pageSize = $event),
          onPagination: getList
        }, null, 8, ["total", "page", "limit"])]),
        _: 1
      }), _createVNode(ToolForm, {
        ref_key: "formRef",
        ref: formRef,
        onSuccess: getList
      }, null, 512)], 64);
    };
  }
});